import React from 'react'
import { render } from 'react-dom'
import { Router, Route, browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import { ApolloProvider } from 'react-apollo'

import apolloClient from './apollo'
import configureStore from './store'
// import setBackboneVariables from './utils/backbone'

// react-boilerplate uses a format like this to build routes. Since we can't have one root node yet,
// we need to iterate over several "environments" and attach them to the proper dom element.
// For easy reference, this uses a similar way of attaching as the boilerplate.
// Note: order of "environments" matter if they are dependent on a async loaded reducer
import exposeEnvironments from './environments'

if (!global._babelPolyfill) {
  require('babel-polyfill')
}

const initialState = {}
export const store = configureStore(initialState, browserHistory)
const history = syncHistoryWithStore(browserHistory, store, {
  selectLocationState (state) {
    return state.routing
  }
})
const environments = exposeEnvironments(store)

// setBackboneVariables(store)

// Render all environments in their respective roots
environments.forEach(async (environment) => {
  const rootEl = document.querySelector(environment.rootQuerySelector)
  if (!rootEl) return false

  let router
  if (environment.getRoutes) {
    // For single-page apps
    router = <Router history={history} routes={await environment.getRoutes()} />
  } else {
    // For multiple components on page (during transition backbone -> react)
    // Note: this was the initial situation. Still not sure if multiple routers work on one page... we might just need
    // a `getComponent` function wrapped by Provider
    router = (
      <Router history={history}>
        <Route path="*" getComponent={environment.getComponent} />
      </Router>
    )
  }

  return render((
    <ApolloProvider store={store} client={apolloClient}>
      {router}
    </ApolloProvider>
  ), rootEl)
})

// @TODO
// Make the router read from an object
// load the object async from route(s) in an eviroment
// get the loadAsyncInjector to the route
// load the routes like we normally do
